module.exports = __webpack_public_path__ + "img/icon-remote.b41cbc1f.svg";